export { HeapIdentifier } from './HeapIdentifier';
